<template>
    <ul class="listing pages pagination">
        <li>
            <button
                type="button"
                class="icon pagination-btn"
                :class="{ 'link-like': currentPage > 1 }"
                :disabled="currentPage <= 1"
                @click="
                    changePage(currentPage > 1 ? currentPage - 1 : currentPage)
                "
            >
                <svg-icon id="paginationLeft"></svg-icon>
            </button>
        </li>
        <li v-for="x in pageNumbers">
            <span
                :class="{
                    current: x == currentPage,
                    'link-like': x != currentPage,
                }"
                @click="changePage(x)"
                >{{ x }}</span
            >
        </li>
        <li>
            <button
                type="button"
                class="icon pagination-btn"
                :class="{ 'link-like': currentPage < totalPages }"
                :disabled="currentPage >= totalPages"
                @click="
                    changePage(
                        currentPage < totalPages ? currentPage + 1 : currentPage
                    )
                "
            >
                <svg-icon id="paginationRight"></svg-icon>
            </button>
        </li>
    </ul>
</template>

<script>
export default {
    props: {
        currentPage: {
            type: Number,
            required: true,
        },

        divisions: {
            type: Number,
            default: 4,
        },

        itemsPerPage: {
            type: Number,
            default: 25,
        },

        range: {
            type: Number,
            default: 3,
        },

        totalPages: {
            type: Number,
            required: true,
        },
    },

    data() {
        return {
            perPage: this.itemsPerPage,
            page: 1,
        };
    },

    computed: {
        mobileMode() {
            return this.$store.getters["isMobile"];
        },

        pageNumbers() {
            var division_size = this.totalPages / this.responsiveDivisions;
            var pages = [];

            // Always have page 1
            pages.push(1);

            // And the current page
            pages.push(this.currentPage);

            // Add pages within x places of the current page
            for (
                var x = Math.max(1, this.currentPage - this.responsiveRange);
                x <=
                Math.min(
                    this.totalPages,
                    this.currentPage + this.responsiveRange
                );
                x++
            ) {
                pages.push(x);
            }

            // And the numbers per page division
            for (var x = 1; x < this.responsiveDivisions; x++) {
                var page_number = Math.round(division_size * x);

                if (page_number > 0) {
                    pages.push(page_number);
                }
            }

            // And the last page
            pages.push(this.totalPages);

            // Sort it
            pages.sort(function (a, b) {
                if (a == b) {
                    return 0;
                }

                return a > b ? 1 : -1;
            });

            return pages.filter(function (el, index, arr) {
                return index === arr.indexOf(el);
            });
        },

        responsiveRange() {
            return this.mobileMode ? 2 : this.range;
        },

        responsiveDivisions() {
            return this.mobileMode ? 3 : this.divisions;
        },
    },

    methods: {
        changePage(to) {
            this.$emit("change-page", to);
        },
    },
};
</script>
